module.exports = __webpack_public_path__ + "img/Outdoor.7fb8293.jpg";